module.exports = __webpack_public_path__ + "img/vr.7fb84480.svg";